<template>
  <div class="app">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'videolayout'
}
</script>
<style scoped lang="scss">
.app {
  width: 100%;
  height: 100%;
  display: block;
  background-color: #000;
}
</style>
